
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

const PolitiqueCookiesPage = () => {
  return (
    <>
      <header>
        <h1 className="sr-only">Politique de cookies - SARL ADF Biomédical Algérie</h1>
      </header>
      <Navbar />
      <main>
        {/* HERO SECTION */}
        <section className="relative pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <p className="text-sm text-text-secondary mb-6">
                <Link to="/" className="hover:text-[#E31B23] transition-colors cursor-pointer">Accueil</Link> / Politique de cookies
              </p>
              <h2 className="text-5xl md:text-6xl font-bold text-text-primary mb-6">
                Politique de cookies
              </h2>
              <p className="text-xl text-text-secondary max-w-3xl mx-auto">
                Utilisation des cookies sur notre site web
              </p>
            </motion.div>
          </div>
        </section>

        {/* CONTENU */}
        <section className="py-24 bg-white">
          <div className="max-w-4xl mx-auto px-6 lg:px-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="space-y-12"
            >
              {/* Introduction */}
              <div>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed mb-4">
                    Cette politique de cookies explique ce que sont les cookies, comment nous les utilisons sur le site adfbiomedical.dz, les types de cookies que nous utilisons, les informations que nous collectons à l'aide de cookies et comment ces informations sont utilisées.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Date de dernière mise à jour :</strong> Janvier 2025
                  </p>
                </div>
              </div>

              {/* Qu'est-ce qu'un cookie */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-information-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Qu'est-ce qu'un cookie ?
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Un cookie est un petit fichier texte stocké sur votre ordinateur ou appareil mobile lorsque vous visitez un site web. Les cookies permettent au site web de reconnaître votre appareil et de mémoriser certaines informations sur vos préférences ou actions passées.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Les cookies peuvent être "persistants" ou "de session". Les cookies persistants restent sur votre appareil après la fermeture du navigateur, tandis que les cookies de session sont supprimés dès que vous fermez votre navigateur.
                  </p>
                </div>
              </div>

              {/* Types de cookies */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-list-check text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Types de cookies utilisés
                </h3>
                <div className="space-y-6">
                  {/* Cookies essentiels */}
                  <div className="bg-gray-50 rounded-xl p-8">
                    <h4 className="text-xl font-bold text-text-primary mb-4 flex items-center">
                      <i className="ri-shield-check-line text-[#E31B23] mr-3 w-6 h-6 flex items-center justify-center"></i>
                      1. Cookies essentiels
                    </h4>
                    <p className="text-base text-text-secondary leading-relaxed mb-4">
                      Ces cookies sont nécessaires au fonctionnement du site web et ne peuvent pas être désactivés dans nos systèmes. Ils sont généralement établis en réponse à des actions que vous effectuez et qui constituent une demande de services.
                    </p>
                    <p className="text-base text-text-secondary leading-relaxed">
                      <strong className="text-text-primary">Exemples :</strong> cookies de session, cookies de sécurité, cookies de préférence linguistique
                    </p>
                  </div>

                  {/* Cookies de performance */}
                  <div className="bg-gray-50 rounded-xl p-8">
                    <h4 className="text-xl font-bold text-text-primary mb-4 flex items-center">
                      <i className="ri-speed-line text-[#E31B23] mr-3 w-6 h-6 flex items-center justify-center"></i>
                      2. Cookies de performance
                    </h4>
                    <p className="text-base text-text-secondary leading-relaxed mb-4">
                      Ces cookies nous permettent de compter les visites et les sources de trafic afin de mesurer et d'améliorer les performances de notre site. Ils nous aident à savoir quelles pages sont les plus et les moins populaires et à voir comment les visiteurs naviguent sur le site.
                    </p>
                    <p className="text-base text-text-secondary leading-relaxed">
                      <strong className="text-text-primary">Exemples :</strong> Google Analytics, statistiques de fréquentation
                    </p>
                  </div>

                  {/* Cookies fonctionnels */}
                  <div className="bg-gray-50 rounded-xl p-8">
                    <h4 className="text-xl font-bold text-text-primary mb-4 flex items-center">
                      <i className="ri-settings-3-line text-[#E31B23] mr-3 w-6 h-6 flex items-center justify-center"></i>
                      3. Cookies fonctionnels
                    </h4>
                    <p className="text-base text-text-secondary leading-relaxed mb-4">
                      Ces cookies permettent au site web de fournir des fonctionnalités et une personnalisation améliorées. Ils peuvent être établis par nous ou par des tiers dont nous avons ajouté les services à nos pages.
                    </p>
                    <p className="text-base text-text-secondary leading-relaxed">
                      <strong className="text-text-primary">Exemples :</strong> mémorisation des préférences utilisateur, personnalisation du contenu
                    </p>
                  </div>

                  {/* Cookies publicitaires */}
                  <div className="bg-gray-50 rounded-xl p-8">
                    <h4 className="text-xl font-bold text-text-primary mb-4 flex items-center">
                      <i className="ri-advertisement-line text-[#E31B23] mr-3 w-6 h-6 flex items-center justify-center"></i>
                      4. Cookies publicitaires
                    </h4>
                    <p className="text-base text-text-secondary leading-relaxed mb-4">
                      Ces cookies peuvent être établis au sein de notre site web par nos partenaires publicitaires. Ils peuvent être utilisés par ces sociétés pour établir un profil de vos intérêts et vous proposer des publicités pertinentes sur d'autres sites.
                    </p>
                    <p className="text-base text-text-secondary leading-relaxed">
                      <strong className="text-text-primary">Note :</strong> Actuellement, nous n'utilisons pas de cookies publicitaires sur notre site.
                    </p>
                  </div>
                </div>
              </div>

              {/* Cookies tiers */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-global-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Cookies tiers
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    En plus de nos propres cookies, nous pouvons également utiliser des cookies tiers pour signaler des statistiques d'utilisation du site web, diffuser des publicités sur et via le site web, etc.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    <strong className="text-text-primary">Services tiers utilisés :</strong>
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Google Analytics :</strong> pour analyser l'utilisation du site web
                    </li>
                  </ul>
                </div>
              </div>

              {/* Gestion des cookies */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-settings-4-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Comment gérer les cookies ?
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed mb-4">
                    Vous pouvez contrôler et/ou supprimer les cookies comme vous le souhaitez. Vous pouvez supprimer tous les cookies déjà présents sur votre ordinateur et paramétrer la plupart des navigateurs pour qu'ils les bloquent.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed mb-4">
                    <strong className="text-text-primary">Pour gérer les cookies dans votre navigateur :</strong>
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Google Chrome :</strong> Paramètres &gt; Confidentialité et sécurité &gt; Cookies
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Mozilla Firefox :</strong> Options &gt; Vie privée et sécurité &gt; Cookies
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Safari :</strong> Préférences &gt; Confidentialité &gt; Cookies
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Microsoft Edge :</strong> Paramètres &gt; Confidentialité &gt; Cookies
                    </li>
                  </ul>
                  <p className="text-base text-text-secondary leading-relaxed mt-6">
                    <strong className="text-text-primary">Attention :</strong> Si vous bloquez tous les cookies, certaines fonctionnalités du site web peuvent ne pas fonctionner correctement.
                  </p>
                </div>
              </div>

              {/* Durée de conservation */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-time-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Durée de conservation des cookies
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    La durée de conservation des cookies varie selon leur type :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Cookies de session :</strong> supprimés à la fermeture du navigateur
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <strong className="text-text-primary">Cookies persistants :</strong> conservés jusqu'à 13 mois maximum
                    </li>
                  </ul>
                </div>
              </div>

              {/* Consentement */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-hand-heart-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Votre consentement
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    En utilisant notre site web, vous consentez à l'utilisation de cookies conformément à cette politique de cookies. Lors de votre première visite sur notre site, un bandeau d'information vous demande d'accepter ou de refuser les cookies non essentiels.
                  </p>
                  <p className="text-base text-text-secondary leading-relaxed">
                    Vous pouvez modifier vos préférences à tout moment en gérant les paramètres de votre navigateur.
                  </p>
                </div>
              </div>

              {/* Modifications */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-refresh-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Modifications de la politique
                </h3>
                <div className="bg-gray-50 rounded-xl p-8">
                  <p className="text-base text-text-secondary leading-relaxed">
                    SARL ADF Biomédical se réserve le droit de modifier cette politique de cookies à tout moment. Toute modification sera publiée sur cette page avec une nouvelle date de mise à jour. Nous vous encourageons à consulter régulièrement cette page pour prendre connaissance des éventuelles modifications.
                  </p>
                </div>
              </div>

              {/* Plus d'informations */}
              <div>
                <h3 className="text-3xl font-bold text-text-primary mb-6 flex items-center">
                  <i className="ri-information-line text-[#E31B23] mr-4 w-8 h-8 flex items-center justify-center"></i>
                  Plus d'informations
                </h3>
                <div className="bg-gray-50 rounded-xl p-8 space-y-4">
                  <p className="text-base text-text-secondary leading-relaxed">
                    Pour plus d'informations sur les cookies et comment les gérer, vous pouvez consulter les sites suivants :
                  </p>
                  <ul className="space-y-3">
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <a href="https://www.cnil.fr/fr/cookies-les-outils-pour-les-maitriser" target="_blank" rel="noopener noreferrer" className="text-[#E31B23] hover:underline cursor-pointer">CNIL - Cookies : les outils pour les maîtriser</a>
                    </li>
                    <li className="flex items-start text-base text-text-secondary">
                      <i className="ri-checkbox-circle-fill text-[#E31B23] mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <a href="https://www.allaboutcookies.org/" target="_blank" rel="noopener noreferrer" className="text-[#E31B23] hover:underline cursor-pointer">All About Cookies</a>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Contact */}
              <div className="bg-gradient-to-r from-[#E31B23] to-[#C41820] rounded-2xl p-12 text-center">
                <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-white/20 rounded-full">
                  <i className="ri-question-line text-5xl text-white"></i>
                </div>
                <h4 className="text-3xl font-bold text-white mb-4">Questions sur les cookies ?</h4>
                <p className="text-lg text-white/90 mb-8">
                  Notre équipe est à votre disposition pour répondre à toutes vos questions
                </p>
                <Link
                  to="/contact"
                  className="inline-block px-10 py-4 bg-white text-[#E31B23] rounded-lg font-semibold text-lg hover:bg-gray-100 transition-all duration-300 shadow-lg cursor-pointer whitespace-nowrap"
                >
                  Nous contacter
                </Link>
              </div>
            </motion.div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default PolitiqueCookiesPage;
